exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-5ec52921] {\n  padding-top: 5rem;\n}\n.navbar-dark .navbar-nav .nav-link[data-v-5ec52921] {\n  color: white;\n}\n.no-results[data-v-5ec52921] {\n  text-align: center;\n  min-height: 300px;\n  color: darkgray;\n}\n.no-results i[data-v-5ec52921] {\n  font-size: 3rem;\n  margin-bottom: 10px;\n}", ""]);

// exports
